import * as React from 'react';
export const bbtSvg = React.forwardRef(function bbtSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#903',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M21.9 14.15h.22c.08-.93.66-1.5 1.25-1.5h.98v6.09c.05.51-.44.7-1.04.7v.2h3.9v-.2c-.62-.07-1.13-.05-1.12-.6v-6.19H27c.59 0 1.31.47 1.31 1.5h.23v-1.83h-6.63v1.83zm-2.26-1.35c.7 0 .84.69.66 1.03-.3.58-.72.72-.73.7-.24-.38-.56-.78-.56-1.13 0-.28.23-.6.63-.6zm-1.34 2.8s1.03 1.95 2.11 2.96c-.42.35-1.7.51-2.5-.91-.53-.95-.14-1.64.39-2.05zm-5.43.43c1.13-.1 1.54.67 1.6 1.46.07.96-.34 1.78-1.38 1.78-.46 0-.65-.15-.65-.64v-2.6h.43zm5.81 3.86c.74.01 1.42-.17 2.22-.88.3.23.7.62 1.33.66.17 0 .7-.09 1.15-.6.37-.45.44-.78.45-.8l-.19-.13c-.12.24-.33.42-.59.42-.48 0-.51-.18-1.08-.7.57-.78.54-1.18.84-1.59.32-.41.58-.65 1.1-.66v-.21h-1.94v.18c.39-.02.45.26.4.5-.1.49-.65 1.49-.72 1.41-.83-.81-1.85-2.6-1.85-2.6a2.02 2.02 0 0 0 1.04-1.37c0-.7-.38-1.28-1.47-1.4-.66-.08-1.91.43-1.94 1.5 0 .5.32.98.65 1.59-.88.32-1.57.96-1.86 1.78-.34-.76-1.29-1.06-1.9-1.21.48-.14 1.89-.4 1.83-1.63-.08-1.6-2.28-1.88-3.06-1.83H9.68v.21c.5.03 1-.1 1 .7v5.48c0 .66-.38.67-1 .73v.2h3.56c1.92.01 2.72-.5 3-1.28.31.6 1.11 1.51 2.44 1.53zm-11.67-.26c2.48-.08 3.17-.84 3.17-2.03 0-1.23-1.16-1.61-1.92-1.8.42-.08 1.69-.55 1.67-1.67-.03-1.6-2.27-1.86-3.06-1.8h-3.4v.2c.5.03 1-.1 1 .7v5.46c0 .66-.4.69-1.01.75v.2H7zm-.36-3.62c1-.02 1.58.5 1.65 1.46.06.97-.36 1.77-1.43 1.78-.46 0-.65-.15-.65-.64V16h.43zM8.12 14c0 .98-.33 1.73-1.9 1.69V12.7h.5c1.1.07 1.4.96 1.4 1.28zm6.21 0c0 .99-.32 1.74-1.88 1.7v-2.97h.5c1.1.07 1.38.95 1.38 1.28z',
      }),
    ),
  );
});
bbtSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bbt = {
  category: 'brand',
  colorable: false,
  name: 'bbt',
  svg: bbtSvg,
};
